import { cn } from "@/lib/utils";
import { AvatarFallback, AvatarImage, Avatar as ShadcnAvatar } from "./ui/avatar";

const tones = [
    { bg: 'rgba(145, 160, 188, 0.16)', fg: '#C6D0E2' },
    { bg: 'rgba(145, 160, 188, 0.28)', fg: '#E6EAF1' },
    { bg: 'rgba(255, 255, 255, 0.08)', fg: '#FFFFFF' },
    { bg: 'rgba(255, 255, 255, 0.14)', fg: '#E6EAF1' },
    { bg: 'rgba(91, 104, 128, 0.42)', fg: '#D4DCE9' },
    { bg: 'rgba(198, 208, 226, 0.22)', fg: '#FFFFFF' },
    { bg: 'rgba(16, 18, 26, 0.9)', fg: '#C6D0E2' },
    { bg: 'rgba(145, 160, 188, 0.4)', fg: '#10121A' },
];

const getInitials = (username: string) => {
    username = username.normalize('NFKD').replace(/[̀-ͯ]/g, '');
    let letters = '';
    if (/^[A-Z][a-z]*((?:[A-Z][a-z]*)+)$/.test(username)) {
        const upperCaseLetters = username.match(/[A-Z]/g);
        letters = upperCaseLetters ? upperCaseLetters.slice(0, 2).join('') : '??';
    } else if (/^[a-z]+([_\-.][a-z]+)+$/.test(username)) {
        const words = username.split(/[_\-.]/);
        letters = words[0][0] + words[1][0];
    } else {
        const justAlphanumerics = username.replace(/[^a-zA-Z0-9]/g, '');
        if (justAlphanumerics.length === 0) {
            letters = username.length ? username[0] : '??';
        } else if (justAlphanumerics.length <= 2) {
            letters = justAlphanumerics;
        } else {
            letters = justAlphanumerics[0] + justAlphanumerics[justAlphanumerics.length - 1];
        }
    }
    return letters.toLocaleUpperCase();
};

const getUsernameTone = (username: string) => {
    let hash = 0;
    for (let i = 0; i < username.length; i++) {
        const char = username.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash;
    }
    return tones[Math.abs(hash) % tones.length];
};


type Props = {
    username: string;
    profilePicture?: string;
    className?: string;
};
export default function Avatar({ username, profilePicture, className }: Props) {
    const tone = getUsernameTone(username);
    return <ShadcnAvatar
        className={cn('bg-fc-surface transition-colors', className)}
    >
        {
            profilePicture &&
            <AvatarImage
                src={profilePicture}
                alt={username}
            />
        }
        <AvatarFallback
            className={cn('text-[12px] font-semibold tracking-[0.5px]', className)}
            style={{ backgroundColor: tone.bg, color: tone.fg }}
            delayMs={profilePicture ? 1000 : undefined}
        >
            {getInitials(username)}
        </AvatarFallback>
    </ShadcnAvatar>;
}
